export enum CommandResultCode {
    Ok = 200,
    NotFound = 404,
    NotAuthorized = 401,
    ValidationError = 400,
    ServerError = 500
}